<template>
  <div class="Politics">
    <BannerImg :img-url="$StaticFileUrl + '/mp/BannerImage/politics_banner_3.jpg'">
      <div class="title wow fadeInDown" data-wow-duration="1s">政企全场景数字化服务解决方案</div>
      <div class="desc wow fadeInDown" data-wow-duration="1s">提供一站式聚合供应的全场景运营服务，提升客户体验和满意度</div>
      <div class="flex-row flex-col-center">
        <div class="btn-red wow flipInX" data-wow-duration="1s" style="margin-top: 100px">立即咨询</div>
        <div class="btn-red-linear wow flipInX" data-wow-duration="1s" style="margin-top: 100px">免费试用</div>
      </div>
    </BannerImg>
  </div>
</template>

<script>
import WOW from 'wowjs'
import BannerVideo from '@/components/BannerVideo'

/**
 * @author  XuHongli
 * @date  2022/12/28 10:12
 * @version 1.0
 * @description
 */
import BannerImg from '@/components/BannerImg'
export default {
  name: 'Politics',
  components: {
    BannerImg,
  },
  mounted() {
    new WOW.WOW().init()
  }
}
</script>

<style scoped>

</style>
